import React from "react";
import { LefthandGlobalNavBar } from "./LefthandGlobalNavBar";
import { LeftNavItem } from './LefthandGlobalNavItem';
import './LefthandGlobalNav.scss';

export interface LefthandGlobalNavWrapperProps {
  items: Array<LeftNavItem>;
}
export const LefthandGlobalNavWrapper: React.FC<LefthandGlobalNavWrapperProps> = ({items}) => ( <LefthandGlobalNavBar items={items} /> );
export default LefthandGlobalNavWrapper;
